import React from 'react';
import NTPLogo from "ntp-logo-react";

function CardPayment(props) {
    return (
        <div className="cardpayment">
            <NTPLogo color="#ffffff" version="orizontal" secret="148502" />
        </div>
    );
}

export default CardPayment;
